<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-buttons slot="end">
      @if (showBackButton) {
        <ion-button (click)="back()">
          <ion-icon slot="icon-only" name="arrow-back-outline"></ion-icon>
        </ion-button>
      }
      @if (develop) {
        <ion-button>
          <ion-badge color="danger">
            <div>Development</div>
            <ion-text>v{{ appInfo.version }}</ion-text>
          </ion-badge>
        </ion-button>
      }
    </ion-buttons>
    <ion-title>{{ pageTitle | translate }}</ion-title>
  </ion-toolbar>
</ion-header>
